document.addEventListener('DOMContentLoaded', function () {

  // Autofocus on modal search
  // --------------------------------------------------
  window.onload = function () {
    console.log('loaded');
    const searchModal = document.querySelector('#search-modal');
    searchModal.addEventListener('show.bs.modal', event => {
      console.log('triggered');
      document.getElementById("input-search").focus();
    })
  }


  // Navbar custom dropdown on mobile
  // --------------------------------------------------
  const navItems = document.querySelectorAll('#main-menu > li');

  if (navItems) {
    const backBtn = document.createElement('li');
    const backBtnA = document.createElement('a');
    backBtn.classList.add('menu-item', 'nav-item', 'js-menu-back');
    backBtnA.classList.add('nav-link');
    backBtnA.textContent = 'Indietro';

    backBtn.append(backBtnA);
    navItems[0].parentNode.prepend(backBtn);

    backBtn.addEventListener('click', function () {
      closeDropdown(backBtn);
    });


    for (let i = 0; i < navItems.length; i++) {
      const item = navItems[i];

      // If item is not a parent
      if (!item.classList.contains('menu-item-has-children')) {
        continue;
      }

      const anchor = item.querySelector('a');
      const url = anchor.getAttribute('href');

      anchor.classList.add('js-nav-a');
      item.classList.add('js-nav-item');

      item.addEventListener('click', () => { openDropdown(item, backBtn) });
    }
  }


  function openDropdown(navItem, backBtn) {
    backBtn.classList.add('selected');

    for (let i = 0; i < navItems.length; i++) {
      const item = navItems[i];

      item.classList.add('js-not-selected');

      item.classList.remove('expanded');


    }

    navItem.classList.add('expanded');
    navItem.classList.remove('js-not-selected');
  }

  function closeDropdown(backBtn) {
    backBtn.classList.remove('selected');

    for (let i = 0; i < navItems.length; i++) {
      const item = navItems[i];

      item.classList.remove('js-not-selected');

      item.classList.remove('expanded');
    }
  }


  // Top Banner: right after the nav
  // --------------------------------------------------
  // Close Banner
  // --------------------------------------------------
  const banner = document.querySelector('#js-banner');

  if (banner) {
    banner.querySelector('#js-banner-close')
      .addEventListener('click', () => { closeBanner(true) });
  }

  function closeBanner(close = false) {

    if (banner) {
      if (close) {
        sessionStorage.setItem('banner-closed', true);
        banner.classList.add('closed');
      }

      if (!sessionStorage.getItem('banner-closed')) {
        banner.classList.remove('closed');
      } else {
        let pageHeader = document.querySelector('#js-page-header');
        let stickys = document.querySelectorAll('.card-article--sticky');

        if (pageHeader) {
          pageHeader.classList.remove('pt-md-xs');
          pageHeader.classList.replace('pt-md', 'pt-xs');
          pageHeader.querySelector('div.row')
            .classList.remove('mt-md-md', 'mt-lg');

        }

        if (stickys) {
          stickys.forEach(sticky => {
            sticky.classList.remove('lg');
          })
        }
      }
    }
  }

  closeBanner();

  // Js listener for burger menu effect
  // --------------------------------------------------
  // var hamburger = document.getElementById('hamburger-icon');
  // hamburger.addEventListener(
  //   'click',
  //   function () {
  //     this.classList.toggle('is-active');
  //   },
  //   false
  // );

});
